import {
  ButtonPayloadEnum,
  MessageContent,
} from "@aichat/types/socket/widget.types";

type ProcessedMessagesParams = {
  messages: MessageContent[];
  isFirstChat: boolean;
  isStreaming: boolean;
  starterSuggestions: string[];
  streamedMsgContent: MessageContent;
};

export const getProcessedMessages = ({
  messages,
  isFirstChat,
  isStreaming,
  starterSuggestions,
  streamedMsgContent,
}: ProcessedMessagesParams): MessageContent[] => {
  const starters = starterSuggestions
    ? starterSuggestions.map((starter, idx) => ({
        id: `${idx}-starter`,
        label: starter,
        payload: {
          type: ButtonPayloadEnum.STARTER,
          value: starter,
        },
      }))
    : [];

  const newMessages = isFirstChat
    ? messages.map((msg, idx) => ({
        ...msg,
        ...(idx === 0
          ? {
              content: {
                ...msg.content,
                buttons: starters,
              },
            }
          : {}),
      }))
    : messages;

  return isStreaming ? [...newMessages, streamedMsgContent] : [...newMessages];
};
